var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,7.49c4.7,0,8.51,3.81,8.51,8.51s-3.81,8.51-8.51,8.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16,
    y: 15.5,
    width: 8.51,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16,
    y: 12.66,
    width: 7.75,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16,
    y: 9.83,
    width: 6.09,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16,
    y: 18.34,
    width: 7.75,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16,
    y: 21.17,
    width: 6.09,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,25.01c-4.97,0-9.01-4.04-9.01-9.01S11.03,6.99,16,6.99v1c-4.42,0-8.01,3.59-8.01,8.01s3.59,8.01,8.01,8.01v1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.59,
    y: 10.87,
    width: 3.16,
    height: 1,
    transform: "translate(-2.28 11.27) rotate(-22.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.25,
    y: 20.13,
    width: 3.16,
    height: 1,
    transform: "translate(-7.53 3.42) rotate(-22.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.67,
    y: 19.05,
    width: 1,
    height: 3.16,
    transform: "translate(-2.28 37.83) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.33,
    y: 9.79,
    width: 1,
    height: 3.16,
    transform: "translate(-7.53 11.48) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.87,
    y: 3.25,
    width: 1,
    height: 3.16,
    transform: "translate(-.98 4.72) rotate(-22.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.13,
    y: 25.59,
    width: 1,
    height: 3.16,
    transform: "translate(-8.82 9.95) rotate(-22.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.05,
    y: 4.33,
    width: 3.16,
    height: 1,
    transform: "translate(8.27 22.04) rotate(-67.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.79,
    y: 26.67,
    width: 3.16,
    height: 1,
    transform: "translate(-18.08 27.28) rotate(-67.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,25.01h-.5V6.99h.5c4.97,0,9.01,4.04,9.01,9.01s-4.04,9.01-9.01,9.01Zm.5-17v15.99c4.18-.26,7.51-3.74,7.51-7.99s-3.32-7.73-7.51-7.99Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.268fbef261c436b91bcf6b6a00d119ef.svg";
export { ForwardRef as ReactComponent };